import loadable from '@loadable/component';
import loadableModule from '../../loadable-module';

const SeoSectionModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "mlp-seo-section" */
            './SeoSection'
        )
    ),
    componentName: 'SeoSection',
    placeholder: {
        placeholderType: 'TitledBlock',
        size: 'lg',
    },
});
export default SeoSectionModule;
